import { TypedDocumentNode, gql } from '@apollo/client';
interface GetResourceHubDataQueryVariables {
  locale: string;
  isOm: boolean;
}

interface ResourceHubAnnouncement {
  content: string;
  metadata: string;
  guid: string;
}
interface GetResourceHubDataQueryResponse {
  getResourceHubData: ResourceHubAnnouncement[];
}

export const getResourceHubDataQuery: TypedDocumentNode<
  GetResourceHubDataQueryResponse,
  GetResourceHubDataQueryVariables
> = gql`
  query getResourceHubData($locale: String!, $isOm: Boolean!) {
    getResourceHubData(locale: $locale, isOm: $isOm) {
      content
      metadata
      guid
    }
  }
`;
